var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.openSupplier("ADD")
            },
          },
        },
        [_vm._v("绑定供应商")]
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "el-table",
            { attrs: { data: _vm.tableData.list } },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "序号", width: "55" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "supplierName", label: "供应商名称" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: "权重" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "productCount", label: "启用商品" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "bindTime", label: "绑定时间" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.openSupplier(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteRecord(scope.row)
                              },
                            },
                          },
                          [_vm._v("移除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("BindSupplierVue", {
        ref: "bindSupplierVueRef",
        attrs: { id: _vm.id },
        on: { refresh: _vm.getSuppliers },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }